module.exports = __webpack_public_path__ + "static/media/house-icon.e369cbae.svg";